<template>
  <section class="page-wrap">
    <!-- 表单 start -->
    <div class="search">
      <div class="search-item">
        <el-input
          v-model="fromData.supplierOrderNo"
          placeholder="输入供货单号"
          clearable
        ></el-input>
      </div>
      <div class="search-item">
        <el-date-picker
          v-model="fromData.deliveryTime"
          type="date"
          placeholder="选择供货日期"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div>
      <div class="search-item">
        <el-input
          v-model="fromData.qcCode"
          placeholder="输入复核单号"
          clearable
        ></el-input>
      </div>
      <div class="search-item">
        <el-select
          filterable
          multiple
          v-model="fromData.storeLogistics"
          clearable
          placeholder="选择城市仓"
          @change="onChangeCityStore"
        >
          <el-option
            v-for="item in cityStoreList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="search-item">
        <el-select
          filterable
          multiple
          v-model="fromData.storeDelivery"
          clearable
          placeholder="选择自提点"
        >
          <el-option
            v-for="item in selfTakeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="search-item">
        <el-select
          v-model="fromData.reviewUserId"
          clearable
          placeholder="选择品控员"
        >
          <el-option
            v-for="item of qualityList"
            :key="item.id"
            :label="item.fullname"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <el-select
          v-model="fromData.reviewStatus"
          clearable
          placeholder="选择品控状态"
        >
          <el-option
            v-for="(item, index) in qualityControlList"
            :key="index"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <el-select
          v-model="fromData.orderTimeFrame"
          clearable
          placeholder="开市时间"
        >
          <el-option
            v-for="(item, index) in openTimeList"
            :key="index"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <el-select
          v-model="fromData.isReturn"
          clearable
          placeholder="是否品控退回"
        >
          <el-option
            v-for="(rItem, rIndex) in isReturnList"
            :key="rIndex"
            :label="rItem.name"
            :value="rItem.value"
          ></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <el-date-picker
          @input="changeReviewTime"
          v-model="fromData.reviewTime"
          type="date"
          placeholder="选择品控日期"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div>
      <div class="search-item">
        <el-input
          v-model="fromData.productName"
          placeholder="输入品名"
          clearable
        ></el-input>
      </div>
      <div class="search-item">
        <el-input
          v-model="fromData.productSkuCode"
          placeholder="输入货号"
          clearable
        ></el-input>
      </div>
      <div class="search-item">
        <el-input
          v-model="fromData.supplierName"
          placeholder="输入供货商"
          clearable
        ></el-input>
      </div>
      <div class="search-item">
        <el-input
          v-model="fromData.qcUserName"
          placeholder="输入复核员"
          clearable
        ></el-input>
      </div>
      <div class="search-item">
        <el-input
          v-model="fromData.buyerName"
          placeholder="输入业务员"
          clearable
        ></el-input>
      </div>
      <div class="search-item">
        <el-select
          v-model="fromData.outStockStatus"
          clearable
          placeholder="选择是否缺货"
        >
          <el-option label="全部" value="0"></el-option>
          <el-option label="缺货" value="1"></el-option>
          <el-option label="不缺货" value="2"></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <el-select
          v-model="fromData.qcReason"
          clearable
          placeholder="选择缺货原因"
        >
          <el-option :label="item.name" :value="item.value" v-for="item in qcReasonlist" :key="item.value"></el-option>
         
        </el-select>
      </div>
      <div class="search-item">
        <el-select
          v-model="fromData.qcStatus"
          clearable
          placeholder="选择复核状态"
        >
          <el-option label="全部" value="0"></el-option>
          <el-option label="未复核" value="1"></el-option>
          <el-option label="复核中" value="3"></el-option>
          <el-option label="已复核" value="2"></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <el-date-picker
          @input="changeQcTime"
          v-model="fromData.qcTime"
          type="date"
          placeholder="选择复核完成日期"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div>
      <div class="search-item">
        <el-time-picker
          v-model="fromData.video_start"
          format="HH:mm"
          value-format="HH:mm"
          placeholder="选择视频提交时间起"
        >
        </el-time-picker>
        <el-time-picker
          v-model="fromData.video_end"
          format="HH:mm"
           value-format="HH:mm"
          placeholder="选择视频提交时间止"
        >
        </el-time-picker>
      </div>
      <div class="search-item">
        <el-time-picker
          v-model="fromData.submit_start"
          format="HH:mm"
           value-format="HH:mm"
          placeholder="选择提交送货开始时间"
        >
        </el-time-picker>
        <el-time-picker
          v-model="fromData.submit_end"
          format="HH:mm"
           value-format="HH:mm"
          placeholder="选择提交送货结束时间"
        >
        </el-time-picker>
      </div>
      <div class="search-item">
        <el-time-picker
          v-model="fromData.searchQcStartTime"
          format="HH:mm"
           value-format="HH:mm"
          placeholder="选择复核开始时间"
        >
        </el-time-picker>
        <el-time-picker
          v-model="fromData.searchQcEndTime"
          format="HH:mm"
           value-format="HH:mm"
          placeholder="选择复核结束时间"
        >
        </el-time-picker>
      </div>
      <div class="search-item">
        <el-time-picker
          v-model="fromData.searchReviewStartTime"
          format="HH:mm"
           value-format="HH:mm"
          placeholder="选择品控开始时间"
        >
        </el-time-picker>
        <el-time-picker
          v-model="fromData.searchReviewEndTime"
          format="HH:mm"
           value-format="HH:mm"
          placeholder="选择品控结束时间"
        >
        </el-time-picker>
      </div>
      <div class="search-item a-center">
        <el-checkbox v-model="fromData.isOvertime">超两小时未品控</el-checkbox>
      </div>
      <div class="search-item a-center">
        <el-checkbox v-model="fromData.isOvertime4">超4小时未复核</el-checkbox>
      </div>
      <div class="search-item a-center">
        <el-checkbox v-model="fromData.isUploadVideo">未上传视频</el-checkbox>
      </div>
      <div class="search-item">
        <el-button
          class="bjsearch"
          type="primary"
          icon="el-icon-refresh"
          @click="onHandleRefresh"
        ></el-button>
      </div>
      <div class="search-item">
        <el-button @click="onHandleBatchEdit" type="warning"
          >批量编辑</el-button
        >
      </div>
      <div class="search-item">
        <el-button @click="onHandleSearch" type="primary" icon="el-icon-search"
          >查询</el-button
        >
      </div>
      <div class="search-item">
        <el-button @click="onHandleExport" type="warning" icon="el-icon-upload2"
          >导出</el-button
        >
      </div>
      <div class="search-item">
        <el-button
          type="warning"
          @click="onClickReview"
          class="checkButton"
          icon="el-icon-s-check"
          >复核确认</el-button
        >
      </div>
    </div>
    <!-- 表单 end -->
    <!-- table start -->
    <div class="table-wrap">
      <el-table
        v-loading="loading"
        border
        :data="dataList"
        height="100%"
        style="width: 100%"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column type="index" width="80" align="center" label="序号">
        </el-table-column>
        <el-table-column label="送货员" prop="qcDeliverName" align="center">
        </el-table-column>
        <el-table-column label="供货单号" prop="supplierOrderNo" align="center">
        </el-table-column>
        <el-table-column label="供货日期" prop="deliveryDate" align="center">
        </el-table-column>
        <el-table-column label="订货数量" prop="purchaseNum" align="center">
        </el-table-column>
        <el-table-column label="复核数量" prop="qcReviewNum" align="center">
        </el-table-column>
        <el-table-column label="是否缺货" prop="isOutStock" align="center">
          <template slot-scope="scope">
            {{
              Object.values(OUT_STOCK_ENUM).find(
                (item) => item.value == scope.row.isOutStock
              ).label
            }}
          </template>
        </el-table-column>
        <el-table-column label="缺货数量" prop="qcNum" align="center">
        </el-table-column>
        <el-table-column label="缺货原因" prop="qcReason" align="center">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="right">
              <div>
                <!-- <div v-if="scope.row.qcReason == '缺货'">
                  <div>提交人: {{ scope.row.qcReasonDeliverName }}</div>
                  <div>提交人：{{ scope.row.qcUser }}</div>
                </div>
                <div v-else>
                  <div>提交人：{{ scope.row.qcReasonDeliverName }}</div>
                  <div>备注: {{ scope.row.qcReasonDesc }}</div>
                </div> -->
                <div v-for="(item,index) in scope.row.qcReasonList" :key="index">{{ item }}</div>
              </div>
              <div slot="reference" class="name-wrapper">
                <!-- {{ scope.row.qcReason }} -->
                  <span v-if="scope.row.qcReasonList[0]">{{ scope.row.qcReasonList[0] }}</span>
                  <span v-if="scope.row.qcReasonList[1]">,{{ scope.row.qcReasonList[1] }}</span>
             
                  <i class="el-icon-question" v-if="scope.row.qcReasonList[0]"></i>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="供应商" prop="supplierName" align="center">
        </el-table-column>
        <el-table-column label="品名" prop="productName" align="center">
        </el-table-column>
        <el-table-column label="品类" prop="productCategoryName" align="center">
        </el-table-column>
        <el-table-column label="货号" prop="productSkuCode" align="center">
        </el-table-column>
        <el-table-column label="业务员" prop="buyerName" align="center">
        </el-table-column>
        <el-table-column label="城市仓" prop="storeLogistics" align="center">
        </el-table-column>
        <el-table-column label="自提点" prop="storeDelivery" align="center">
        </el-table-column>
        <el-table-column label="品控状态" prop="reviewStatus" align="center">
          <template slot-scope="scope">
            {{
              Object.values(REVIEW_STATUS_ENUM).find(
                (item) => item.value == scope.row.reviewStatus
              ).label
            }}
          </template>
        </el-table-column>
        <el-table-column label="开市时间" prop="orderTimeFrame" align="center">
        </el-table-column>
        <el-table-column
          label="品控数量"
          prop="partialQualityControlQuantity"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column
          label="是否品控退回"
          prop="reviewStatus"
          align="center"
        >
          <template slot-scope="scope">
            {{
              Object.values(IS_RETURN_ENUM).find(
                (item) => item.value == scope.row.isReturn
              ).label
            }}
          </template>
        </el-table-column> -->
        <el-table-column label="品控时间" prop="reviewTime" align="center">
        </el-table-column>
        <el-table-column label="品控员" prop="reviewUser" align="center">
        </el-table-column>
        <el-table-column label="复核状态" prop="qcStatus" align="center">
          <template slot-scope="scope">
            {{
              Object.values(IS_CHECK_ENUM).find(
                (item) => item.value == scope.row.qcStatus
              ).label
            }}
          </template>
        </el-table-column>
        <el-table-column label="复核完成时间" prop="qcTime" align="center">
        </el-table-column>
        <el-table-column
          label="视频提交时间"
          prop="videoLastTime"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="提交送货时间"
          prop="supplierDeliverConfirmTime"
          align="center"
        >
        </el-table-column>
        <el-table-column label="复核员" prop="qcUser" align="center">
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button
            v-if="scope.row.qcReasonCode!=5"
              type="text"
              size="mini"
              @click="handleEditClick(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              type="text"
              size="mini"
              @click="handleViewClick(scope.row)"
            >
              查看视频
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fy">
      <el-pagination
        type="primary"
        align="right"
        background
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="fromData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- table end -->

    <!-- 编辑弹窗 start -->
    <el-dialog
      title="编辑"
      :visible.sync="editDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      @close="handleEditDialogClose"
    >
      <el-form
        :model="editForm"
        :rules="editRules"
        ref="editForm"
        label-width="100px"
      >
        <el-form-item label="缺货原因：" prop="qcReason">
          <el-select
            v-model="editForm.qcReason"
            placeholder="请选择缺货原因"
            style="width: 100%"
            @change="handleReasonChange"
          >
            <el-option
              v-for="item in filteredStockOutReasons"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="备注："
          prop="qcReasonDesc"
          v-if="editForm.qcReason === 99"
        >
          <el-input
            type="textarea"
            v-model="editForm.qcReasonDesc"
            placeholder="请输入备注"
            :rows="4"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit" :loading="submitLoading"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <!-- 编辑弹窗 end -->

    <!-- 视频弹窗 start -->
    <VideoPlayerDialog
      :visible.sync="videoDialogVisible"
      :videoList="videoList"
    />
    <!-- 视频弹窗 end -->
  </section>
</template>

<script>
import url from "url";
import { formatDate } from "../../../utils//tools/date.js";
import { BASE } from "@/api";
import { downLoadFlowBlob } from "@/utils/tools/base";
import {
  postQualityControlReviewOnline,
  postlReviewOnlineConfirmAll,
  postUpdateOnlineQcReason,
  getDeliveryVideo,
  exportOnlineReviewList,
} from "@/api/logisticsControl/delivery/index";
import VideoPlayerDialog from "@/components/common/VideoPlayerDialog/index.vue";
import {
  OUT_STOCK_ENUM,
  REVIEW_STATUS_ENUM,
  IS_RETURN_ENUM,
  IS_CHECK_ENUM,
} from "../utils/enum";
import { STOCK_OUT_REASON_SELECT } from "../../general/operation-center/qc-stockout-manage/page/utils/enum/index";
export default {
  name: "ToReviewLog",
  components: {
    VideoPlayerDialog,
  },
  data() {
    return {
      qualityControlList: [
        { name: "全部", value: "0" },
        { name: "未品控", value: "1" },
        { name: "已品控", value: "2" },
        { name: "品控超时", value: "3" },
        { name: "未过品控", value: "4" },
      ], // 选择品控状态参数列表
      isReturnList: [
        { name: "全部", value: "0" },
        { name: "是", value: "2" },
        { name: "否", value: "1" },
      ], // 是否品控退回参数列表
      openTimeList: [
        { name: "全部", value: -1 },
        { name: "早市", value: 2 },
        { name: "午市", value: 1 },
      ],
      qcReasonlist: [
        { name: "缺货", value: 2 },
        { name: "车已满", value: 3 },
        { name: "未开仓", value: 4 },
        { name: "品控退回", value:5 },
        { name: "不收产品退货", value: 12 },
        { name: "其他", value: 99 },
      ],
      fromData: {
        supplierOrderNo: "",
        qcCode: "",
        deliveryTime: formatDate(),
        reviewUserId: "",
        storeLogistics: [],
        storeDelivery: [],
        reviewStatus: "",
        orderTimeFrame: "",
        isReturn: "", // 是否品控退回
        reviewTime: "",
        productName: "",
        productSkuCode: "",
        supplierName: "",
        buyerName: "",
        outStockStatus: "",
        qcUserName: "",
        qcStatus: "",
        qcTime: "",
        qcReason: "",
        page: 1,
        pageSize: 10,
        isOvertime: false,
        isOvertime4: false,
        video_start: "", //视频提交开始时间
        video_end: "", //视频提交结束时间
        submit_start: "", //提交送货开始时间
        submit_end: "", //提交送货结束时间
        searchQcStartTime: "", //复核开始时间
        searchQcEndTime: "", //复核结束时间
        searchReviewStartTime: "", //品控开始时间
        searchReviewEndTime: "", //品控结束时间
        isUploadVideo: false, // 未上传视频 0 否 1 是
      },
      cityStoreList: [], // 城市仓列表
      selfTakeList: [], // 自提点列表
      qualityList: [], // 品控员列表
      dataList: [],
      currentPage: 1,
      total: 0,
      loading: false,
      OUT_STOCK_ENUM,
      REVIEW_STATUS_ENUM,
      IS_RETURN_ENUM,
      IS_CHECK_ENUM,
      supplyOrderIds: [],
      // 编辑弹窗相关
      editDialogVisible: false,
      submitLoading: false,
      editForm: {
        qcReason: "",
        qcReasonDesc: "",
      },
      editRules: {
        qcReason: [
          { required: true, message: "请选择缺货原因", trigger: "change" },
        ],
        qcReasonDesc: [
          { required: false, message: "请输入备注", trigger: "blur" },
        ],
      },
      currentEditingIds: [],
      filteredStockOutReasons: [],
      videoDialogVisible: false,
      videoList: [],
      supplierOrderIds: [],
    };
  },
  created() {
    this.initStockOutReasons();
    this.getQualityList();
    this.onHandleSearch();
    this.getAjaxCityStoreList();
    this.getAjaxSelfTakeList();
  },
  methods: {
    // 品控日期 为null 转换空字符串
    changeReviewTime(val) {
      if (!val) {
        this.fromData.reviewTime = "";
      }
    },
    // 复核日期 为null 转换空字符串
    changeQcTime(val) {
      if (!val) {
        this.fromData.qcTime = "";
      }
    },
    // 获取城市仓列表
    getAjaxCityStoreList: async function () {
      const params = {
        name: "",
        page: 1,
        pageSize: 1000,
      };
      try {
        const { data } = await this.$api.logistics.entruckLogisticslist(params);
        this.cityStoreList = data.data;
      } catch (err) {
        console.log("ajx getAjaxCityStoreList err", err);
      }
    },
    /**
     * 获取自提点列表
     */
    getAjaxSelfTakeList: async function (logisticsId) {
      //城市仓为必传参数
      if (!logisticsId?.length) {
        return;
      }
      const params = {
        logistics_id: logisticsId,
        page: 1,
        pageSize: 1000,
      };
      try {
        const { data } = await this.$api.logistics.entruckDeliverylist(params);
        this.selfTakeList = data.data;
      } catch (err) {
        console.log("ajx getAjaxSelfTakeList err", err);
      }
    },
    /*
     * 城市仓发生变化
     */
    onChangeCityStore(data) {
      this.selfTakeList = []; // 重置自提点
      this.fromData.storeDelivery = []; // 重置自提点搜索
      if (data?.length) {
        this.getAjaxSelfTakeList(data);
      }
    },
    /**
     * 刷新数据
     */
    onHandleRefresh() {
      // 清空搜索
      this.fromData = {
        supplierOrderNo: "",
        qcCode: "",
        deliveryTime: formatDate(),
        reviewUserId: "",
        storeLogistics: [],
        storeDelivery: [],
        reviewStatus: "",
        orderTimeFrame: "",
        reviewTime: "",
        productName: "",
        productSkuCode: "",
        supplierName: "",
        buyerName: "",
        outStockStatus: "",
        qcUserName: "",
        qcStatus: "",
        qcTime: "",
        page: 1,
        pageSize: 10,
        isOvertime: false,
        isOvertime4: false,
        searchQcStartTime: "",
        searchQcEndTime: "",
        searchReviewStartTime: "",
        searchReviewEndTime: "",
        isUploadVideo: false,
      };
      this.onHandleSearch();
    },
    // 获取品控员列表
    async getQualityList() {
      try {
        const res = await this.$api.logistics.getControlList({
          page: 1,
          pageSize: 1000,
        });
        this.qualityList = res?.data?.data || [];
      } catch (err) {
        console.log("ajax err", err);
      }
    },
    /**
     * 搜索
     */
    onHandleSearch() {
      try {
        // TODO
        this.fromData.page = 1;
        this.currentPage = 1;
        this.onHandleData();
      } catch (err) {
        console.log("ajax err", err);
      }
    },
    /**
     * 请求列表数据
     */
    async onHandleData() {
      if (!this.fromData.deliveryTime) {
        this.tool.message("请选择供货日期", "error");
        return;
      }
      let tmpParam = JSON.parse(JSON.stringify(this.fromData));
      if (tmpParam.orderTimeFrame === -1 || !tmpParam.orderTimeFrame) {
        delete tmpParam.orderTimeFrame;
      }
      if (tmpParam.isOvertime) {
        tmpParam.qualityControlHour = 1;
      }
      if (tmpParam.isOvertime4) {
        tmpParam.noQcHour = 1;
      }
      // 未上传视频 勾选为1(是) 未勾选为0(否) 默认不传
      if (tmpParam.isUploadVideo) {
        tmpParam.isUploadVideo = 1;
      } else {
        tmpParam.isUploadVideo = 0;
      }
      delete tmpParam.isOvertime;
      delete tmpParam.isOvertime4;
      console.log(this.fromData, tmpParam, "122");
      try {
        this.loading = true;
        const res = await postQualityControlReviewOnline(tmpParam);
        this.dataList = res.data.data;
        this.total = res.data.total;
        this.loading = false;
      } catch (err) {
        console.log("ajax err", err);
      }
    },
    /**
     * 编辑
     */
    handleEditClick(row) {
      this.currentEditingIds = [row.itemId];
      this.editDialogVisible = true;
    },
    /**
     * 初始化缺货原因
     */
    initStockOutReasons() {
      const allowedIds = [2, 3, 4, 99,12];
      this.filteredStockOutReasons = STOCK_OUT_REASON_SELECT.filter((item) =>
        allowedIds.includes(item.id)
      );
    },
    /**
     * 缺货原因改变
     */
    handleReasonChange(val) {
      if (val === 99) {
        this.editRules.qcReasonDesc[0].required = true;
      } else {
        this.editRules.qcReasonDesc[0].required = false;
        this.$refs.editForm.clearValidate("qcReasonDesc");
      }
    },
    /**
     * 关闭弹窗
     */
    handleEditDialogClose() {
      this.$refs.editForm.resetFields();
      this.editRules.qcReasonDesc[0].required = false;
      this.currentEditingIds = [];
    },
    /**
     * 批量编辑
     */
    onHandleBatchEdit() {
      if (this.supplyOrderIds.length === 0) {
        this.tool.message("请选择需要编辑的供货单！", "error");
        return;
      }
      this.currentEditingIds = [...this.supplyOrderIds];
      this.editDialogVisible = true;
    },
    /**
     * 提交编辑
     */
    async submitEdit() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          try {
            this.submitLoading = true;
            const params = {
              entruck_detail_ids: this.currentEditingIds,
              qc_reason: this.editForm.qcReason,
              qc_reason_desc: this.editForm.qcReasonDesc,
            };
            await postUpdateOnlineQcReason(params);
            this.tool.message("修改成功", "success");
            this.editDialogVisible = false;
            this.onHandleSearch();
          } catch (err) {
            console.log(err);
          } finally {
            this.submitLoading = false;
          }
        }
      });
    },
    /**
     * 查看视频
     */
    async handleViewClick(row) {
      try {
        const res = await getDeliveryVideo({ entruck_detail_id: row.itemId });

        this.videoList = res.data || [];
        if (this.videoList.length === 0) {
          this.tool.message("暂无视频", "warning");
          return;
        }
        this.videoDialogVisible = true;
      } catch (err) {
        console.log(err);
      }
    },
    /**
     * 导出
     */
    // async onHandleExport() {
    //   if (!this.fromData.deliveryTime) {
    //     this.tool.message("请选择供货日期", "error");
    //     return;
    //   }
    //   try {
    //     const query = {
    //       ...this.fromData,
    //     };
    //     query.storeDelivery = JSON.parse(
    //       JSON.stringify(this.fromData.storeDelivery)
    //     ).join(",");
    //     query.storeLogistics = JSON.parse(
    //       JSON.stringify(this.fromData.storeLogistics)
    //     ).join(",");
    //     if (query.orderTimeFrame === -1 || !query.orderTimeFrame) {
    //       console.log("没值1222");
    //       delete query.orderTimeFrame;
    //     }
    //     if (query.isOvertime) {
    //       query.qualityControlHour = 1;
    //     }
    //     if (query.isOvertime4) {
    //       query.noQcHour = 1;
    //     }
    //     delete query.isOvertime;
    //     delete query.isOvertime4;

    //     const res = await exportOnlineReviewList(query);
    //     downLoadFlowBlob(res, res?.filename);
    //     this.tool.message("导出成功", "success");
    //   } catch (err) {
    //     console.log("ajax err", err);
    //     this.tool.message("导出失败", "error");
    //   }
    // },
    async onHandleExport() {
      if (
        !this.fromData.deliveryTime ||
        (Array.isArray(this.fromData.deliveryTime) &&
          this.fromData.deliveryTime.length === 0)
      ) {
        this.tool.message("请选择供货日期", "error");
        return;
      }

      const query = {
        ...this.fromData,
        token: sessionStorage.getItem("token"),
      };

      query.storeDelivery = (this.fromData.storeDelivery || []).join(",");
      query.storeLogistics = (this.fromData.storeLogistics || []).join(",");

      if (query.orderTimeFrame === -1 || !query.orderTimeFrame) {
        delete query.orderTimeFrame;
      }

      if (query.isOvertime) query.qualityControlHour = 1;
      if (query.isOvertime4) query.noQcHour = 1;

      // 未上传视频 勾选为1(是) 未勾选为0(否) 默认不传
      if (query.isUploadVideo) {
        query.isUploadVideo = 1;
      } else {
         query.isUploadVideo=0;
      }

      delete query.isOvertime;
      delete query.isOvertime4;

      const params = url.format({ query });

      const path = BASE.PRO2 + "/entruck/list/online/export";

      console.log("导出URL：", path + params);

      window.open(path + params);
    },
    /**
     * 更新了每页数据
     */
    onHandleSizeChange(val) {
      this.fromData.pageSize = val;
      this.onHandleData();
    },
    /**
     * 更新了页码
     */
    onHandleCurrentChange(val) {
      this.fromData.page = val;
      this.currentPage = val;
      this.onHandleData();
    },
    /**
     * 一键复核接口
     */
    async onHandleReview() {
      try {
        this.loading = true;
        const res = await postlReviewOnlineConfirmAll({
          supplyOrderIds: this.supplierOrderIds,
        });
        this.onHandleSearch();
        this.tool.message(`复核成功`, "success");
      } catch (err) {
        console.log("一键复核失败", err);
      }
    },
    /**
     * 多选
     */
    handleSelectionChange(val) {
      this.supplyOrderIds = val.map((item) => item.itemId);
      this.supplierOrderIds = val.map((item) => item.supplierOrderId);
      console.log(this.supplyOrderIds);
    },
    /**
     * 一键复核弹窗
     */
    onClickReview(val) {
      if (this.supplyOrderIds.length === 0) {
        this.tool.message("请选择需要复核的供货单！", "error");
        return;
      }
      this.$confirm(
        "操作一键复核之后未复核的供货单将全部操作复核退款，操作不可撤销修改,是否确认?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          customClass: "jn-confirm-message-style",
          iconClass: "el-icon-warning",
        }
      )
        .then(() => {
          try {
            this.onHandleReview();
          } catch (err) {
            console.log("ajax err", err);
          }
        })
        .catch(() => {
          this.tool.message("取消成功", "info");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  padding: 6px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  .search {
    padding: 15px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    background: #fff;
  }
  .bjsearch {
    background: #333333;
    border-color: #333333;
  }
  .checkButton {
    background: #1389ae;
    border-color: #1389ae;
  }
  .el-button--warning.is-disabled {
    background: #1389ae;
    border-color: #1389ae;
  }
  // .checkButton .is_disabled {
  //   background: #1389ae;
  //   border-color: #1389ae;
  // }
  .fy {
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .search-item {
    .el-input {
      width: 207px;
    }
    .el-select {
      width: 207px;
    }
  }
  .a-center {
    align-content: center;
  }

  .table-wrap {
    margin-top: 20px;
    padding: 15px;
    background: #fff;
    flex-grow: 1;
    overflow-y: scroll;
  }
}
</style>
